import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { withTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputText from "../InputText/InputText";

const Root = styled.section`
  width: 100%;
  color: ${props => props.theme.color1};
  display: flex;
  padding: 0;
  input {
    text-align: right;
    margin: 0;
    padding-right: 10px;
  }
`;

const Button = styled.button`
  background-color: ${props => props.theme.color2};
  color: ${props => props.theme.color1};
  width: 40px;
  margin: 0;
  outline: none;
`;

export default withTheme(({ number, setNumber, theme }) => {
  const [err, setErr] = useState("");
  const validate = n => {
    try {
      parseInt(n);
      return "";
    } catch (e) {
      return "Should be a number.";
    }
  };
  return (
    <Root>
      <Button onClick={() => setNumber(number - 1)}>
        <FontAwesomeIcon
          icon={["fas", "minus"]}
          size="1x"
          color={theme.color1}
        />
      </Button>
      <div style={{ flexGrow: 1, maxWidth: "100px" }}>
        <InputText
          value={number}
          onChange={e => {
            const err = validate(e.target.value);
            setErr(err);
            if (!err) {
              setNumber(e.target.value);
            }
          }}
        />
      </div>
      <Button onClick={() => setNumber(number + 1)}>
        <FontAwesomeIcon
          icon={["fas", "plus"]}
          size="1x"
          color={theme.color1}
        />
      </Button>
    </Root>
  );
});
